import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { cmsService } from '@services/cms';

import { ProductsItem } from '@app-types/api/statics';
import { FaiTabsEnum, TabConfig } from '@app-types/home-fai';

/**
 * Récupère les données statiques des produits FAI
 * @returns
 */
export async function faiStaticsData(): Promise<ProductsItem[]> {
    try {
        const response = await cmsService.getRocProducts();

        return response.items;
    } catch {
        return [];
    }
}

export async function getFaiTabs(): Promise<{ tabs: TabConfig; defaultTab: FaiTabsEnum }> {
    try {
        const response = await cmsService.getRocTabs();

        let defaultTab = FaiTabsEnum.PURE_BYOU;
        const tabs: TabConfig = {};

        response.items[0].tabs.forEach((tab, index) => {
            if (tab.default_category) {
                defaultTab = tab.slug;
            }

            tabs[tab.slug] = {
                name: tab.category,
                icon: tab.icon,
                order: index,
            };
        });

        return {
            tabs, //modif en attente de conf CE
            defaultTab: defaultTab ?? (response.items[0].tabs[0]!.category as FaiTabsEnum),
        };
    } catch {
        return {
            tabs: {
                [FaiTabsEnum.PURE_BYOU]: {
                    name: 'B&You fibre',
                    icon: IconName.BOX_ULTYM,
                    order: 0,
                },
                [FaiTabsEnum.BOX_INTERNET]: {
                    name: 'Bbox fibre',
                    icon: IconName.BOX_WIFI_6_TV,
                    order: 1,
                },
                [FaiTabsEnum.BOX_5G]: {
                    name: '5G Box',
                    icon: IconName.BOX_4G,
                    order: 2,
                },
                [FaiTabsEnum.FIN_DE_SERIE]: {
                    name: 'Fin de série',
                    icon: IconName.GDT,
                    order: 3,
                },
            },
            defaultTab: FaiTabsEnum.PURE_BYOU,
        };
    }
}

export async function faiComparatorConfig() {
    return cmsService.getFaiComparatorConfig().catch(() => []);
}
